import { createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters';
import { getOverviewEntities, getSharedEntities } from './common.selectors';

export const getEarnsTitle = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getEarnsTitle(overviewEntities['aem-content']?.aemContent?.earns)
);

export const getBanner = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getBanner(
      overviewEntities['aem-content']?.aemContent?.earns.fastActionBanner,
      overviewEntities['multiple-pe-content']?.multiplePEContent,
      sharedEntities['user-session']?.userSession,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.earns.amex,
      [
        overviewEntities['multiple-pe-content-error']?.multiplePEContentError,
        overviewEntities['status-tracker-content-error']
          ?.statusTrackerContentError
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getOffers = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getOffers(
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.earns
        .offers,
      '0',
      overviewEntities['multiple-pe-content']?.multiplePEContent,
      [
        overviewEntities['multiple-pe-content-error']?.multiplePEContentError,
        overviewEntities['status-tracker-content-error']
          ?.statusTrackerContentError // Adding tracker error as Multiple PE is dependent on tracker data
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getRelatedLinks = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getRelatedLinks(
      overviewEntities['aem-content']?.aemContent?.relatedLink,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.relatedLinks
    )
);

export const getPartnersFlag = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.earns.partners
);
